<script lang="ts">
	import { m } from '$lib/paraglide/messages';

	const { icon = false, ...rest } = $props();
</script>

<div
	class={[
		'absolute top-0 right-0 z-10 flex items-center gap-1 rounded-bl bg-green-500 p-0.5 leading-none font-bold text-white uppercase',
		rest?.class,
	]}
>
	{#if icon}
		<div class="icon-[mdi--truck-fast] size-6"></div>
	{/if}
	{m['24h']()}
</div>
